export const defaultPristineConfig = {
  classTo: 'form-control',
  errorClass: 'has-error',
  successClass: 'has-success',
  errorTextParent: 'form-control',
  errorTextTag: 'small',
  errorTextClass: 'form-control__error',
};
